import WYSIWYG from '@components/ui/WYSIWYG'
import cn from 'clsx'
import dynamic from 'next/dynamic'
import Link from 'next/link'
const ReactPlayer = dynamic(() => import('react-player'), { ssr: false })

interface Props {
  slice: any
}

const ColourPdpGuidance = ({ slice }: Props) => {
  const title = slice?.primary?.title
  const text = slice?.primary?.text
  const linktitle = slice?.primary?.linktitle
  const paddingBottom = slice?.primary?.paddingBottom
  return (
    <div
      className={cn('w-full bg-white pt-10 lg:pt-30 ', {
        'pb-4 lg:pb-0': !paddingBottom,
        'pb-20 lg:pb-30': paddingBottom,
      })}
    >
      <div className="wrapper grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 xl:gap-x-8 ">
        {title && (
          <div className="mb-8 lg:mb-0">
            {title && (
              <div className="heading-mobile-3 mb-3 max-w-5xl text-left align-top font-roboto  font-light text-brand-dark-grey lg:text-h3 ">
                {title}
              </div>
            )}
            {text && (
              <div className="mb-4 max-w-5xl text-left align-top font-roboto font-light text-brand-dark-grey ">
                <WYSIWYG content={text} />
              </div>
            )}
            {linktitle && (
              <Link
                href={slice?.primary?.url || '/'}
                target="_blank"
                className="mb-4 max-w-5xl text-left align-top font-roboto font-light text-brand-dark-grey underline underline-offset-1 "
                rel="noreferrer"
              >
                {slice?.primary?.linktitle}
              </Link>
            )}
          </div>
        )}
        <div className="col-span-2 flex flex-col gap-6 lg:flex-row lg:gap-8">
          {slice.items?.map((item: any, index: number) => {
            const linkUrl = item?.link.url
            const videoTitle = item?.title
            const videoText = item?.text
            return (
              linkUrl && (
                <div className="flex flex-col" key={index}>
                  <div className="hidden lg:block">
                    <ReactPlayer url={linkUrl} width="416px" height="234px" />
                  </div>
                  <div className="block lg:hidden">
                    <ReactPlayer url={linkUrl} width="" height="234px" />
                  </div>
                  {videoTitle && (
                    <div className="mb-2 mt-3 text-label font-bold text-brand-dark-grey">
                      {videoTitle}
                    </div>
                  )}
                  {videoText && (
                    <div className="text-body1 text-brand-dark-grey lg:mb-0">
                      <WYSIWYG content={videoText} />
                    </div>
                  )}
                </div>
              )
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default ColourPdpGuidance
